import { useAtomValue } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import H1 from '@/components/base/Headings/H1';
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
import { AlternativeWinners } from '@/components/pages/giveaway-picker/OptionsWrapper/components/AlternativeWinners';
import { Deadline } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Deadline';
import { Hashtags } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Hashtags';
import { NumberOfMentions } from '@/components/pages/giveaway-picker/OptionsWrapper/components/NumberOfMentions';
import { NumberOfWinners } from '@/components/pages/giveaway-picker/OptionsWrapper/components/NumberOfWinners';
import { OnlyUniqueComments } from '@/components/pages/giveaway-picker/OptionsWrapper/components/OnlyUniqueComments';
import { PromotedPostComments } from '@/components/pages/giveaway-picker/OptionsWrapper/components/PromotedPostComments';

export const OptionsWrapper = () => {
    const { t } = useTranslation('giveaway_picker');
    const currentStep = useAtomValue(currentStepAtom);

    if (currentStep !== 3) {
        return null;
    }

    return (
        <div>
            <H1 className="mb-14">{t('options.choose_options_title')}</H1>
            <div className="mb-20 flex flex-col gap-12 px-0.5" data-testid="options-wrapper">
                <Deadline />
                <NumberOfWinners />
                <AlternativeWinners />
                <Hashtags />
                <NumberOfMentions />
                <PromotedPostComments />
                <OnlyUniqueComments />
            </div>
        </div>
    );
};
